import BaseAPIService from '../base/base-api-service';
import * as moment from 'moment';
import ClaimStatusModel from 'src/model/ClaimStatus.model';
import {
  sortType,
  statusType,
  orderType,
  IClaimStatusAPIParams
} from 'src/model/modules/claimstatusvw.model';
import DateRangeModel from 'src/model/dateRange.model';
import i18n from 'src/translation/i18n';
import { Observable } from 'redux';
import filtersIcon from 'src/assets/filtersIcon';
import { LensTwoTone } from '@material-ui/icons';

export interface ICSSvcFilters {
  dateRange: DateRangeModel;
  sort: { type: sortType; order: 'asc' | 'desc' };
  status: statusType;
  orderStatus: orderType;
  // search: searchType;
  csSearchKey: string;
  csSearchVal: string;
}

export interface ICSPartDetailsAPIParams {
  claimType: string;
  prevClaimNumber: string;
  partNumber: string;
}
export interface ICSSvcPagination {
  page: number;
  size?: number;
}

export interface IInvoiceCreditPayment {
  orderNumber: number;
  paymentAmount: number;
  reasonRemainingBalance: string;
  transactionId: number;
}

export interface ICSSvcInitialModel {
  customerNumber: string;
  description: string;
  dueDate: string;
  hasInvoice: boolean;
  invoiceDate: string;
  invoiceNumber: number;
  orderNumber: number;
  remainingAmount: number;
  status: 'PAID' | 'DUE' | 'PAST DUE' | 'PENDING';
  orderStatus: 'RS' | 'RW' | 'NC' | 'CR' | 'IN';
  // invoiceNumber: 'invoiceNumber' ;
  nardaNumber: 'nardaNumber';
  transactionId: number;
}

class ClaimStatusService extends BaseAPIService<ClaimStatusModel> {
  private endpoint: string = 'accountapp/v1/invoice';

  constructor() {
    super(ClaimStatusModel);
  }

  private buildClaimStatusParams = (
    filters: ICSSvcFilters,
    pagination: ICSSvcPagination,
    isHeader?: boolean
  ) => {
    const parameters: any = {
      dateFrom:
        isHeader || pagination.size === 0 || pagination.size
          ? undefined
          : filters.dateRange && filters.dateRange.start
          ? filters.dateRange.start.format('YYYY-MM-DD')
          : undefined,
      dateTo:
        isHeader || pagination.size === 0 || pagination.size
          ? undefined
          : filters.dateRange && filters.dateRange.end
          ? filters.dateRange.end.format('YYYY-MM-DD')
          : undefined,
      page: pagination.page,
      size: pagination.size,
      sort:
        filters.sort && filters.sort.type && filters.sort.order
          ? `${filters.sort.type},${filters.sort.order}`
          : 'claimNo,asc',
      status: filters.status,
      orderStatus: filters.orderStatus,
      csSearchKey: filters.csSearchKey,
      csSearchVal: filters.csSearchVal
    };
    if (isHeader || pagination.size === 0 || pagination.size) {
      parameters['dueDateFrom'] =
        filters.dateRange && filters.dateRange.start
          ? filters.dateRange.start.format('YYYY-MM-DD')
          : undefined;
      parameters['dueDateTo'] =
        filters.dateRange && filters.dateRange.end
          ? filters.dateRange.end.format('YYYY-MM-DD')
          : undefined;
    }
    Object.keys(parameters).forEach(key =>
      !parameters[key] ? delete parameters[key] : ''
    );
    return parameters;
  };

  private buildOldestInvoicesParams = (pagination: ICSSvcPagination) => {
    // console.log(pagination);
    const parameters: any = {
      page: pagination.page,
      size: pagination.size
    };

    return parameters;
  };

  private buildCreditParams = (filters: any, pagination: ICSSvcPagination) => {
    // (pagination);
    const parameters: any = {
      page: pagination.page,
      size: pagination.size,
      invoiceNumber: filters.invoiceNumber
    };
    Object.keys(parameters).forEach(key =>
      !parameters[key] ? delete parameters[key] : ''
    );
    return parameters;
  };

  private setLocalIndex(invoices: ICSSvcInitialModel[]) {
    return invoices.map((invoice, idx) => {
      return {
        ...invoice,
        idx: `${invoice.transactionId}&${invoice.orderNumber}`
      };
    });
  }
  public gClaimTypeLookupData() {
    return new Promise((resolve, reject) => {
      const apiUrl = `${this.baseURL}warrantyapp/v1/part-claim/getAllClaimsTypes`;
      this.doRequest({
        method: 'get',
        url: apiUrl
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          if (response.status === 200) {
            // console.log(result);
            resolve(result);
          } else if (response.status === 204) {
            reject('No Claim Types');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  public gCSSearchKeysLookupData() {
    return new Promise((resolve, reject) => {
      const apiUrl = `${this.baseURL}warrantyapp/v1/part-claim/getAllSearchOptions`;
      this.doRequest({
        method: 'get',
        url: apiUrl
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          if (response.status === 200) {
            // console.log(result);
            resolve(result);
          } else if (response.status === 204) {
            reject('No Claim Search Keys');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public gClaimStatusLookupData() {
    return new Promise((resolve, reject) => {
      const apiUrl = `${this.baseURL}warrantyapp/v1/part-claim/getAllClaimStatus`;
      this.doRequest({
        method: 'get',
        url: apiUrl
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          if (response.status === 200) {
            // console.log(result);
            resolve(result);
          } else if (response.status === 204) {
            reject('No Claim Status');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public getClaimStatusDetails(
    filters: ICSSvcFilters,
    pagination: ICSSvcPagination,
    isHeader?: boolean
  ) {
    // console.log(jData[0].claimNo);
    // console.log('getClaimStatusDetails >>>>>>>>>>>', isHeader);
    return new Promise((resolve, reject) => {
      const params = this.buildClaimStatusParams(filters, pagination, isHeader);
      const i: number = 0;
      const rtnCSData = [];
      const minRnd: number = 1;
      const maxRnd: number = 2;
      do {
        const rndNo = Math.floor(
          Math.random() * (maxRnd - minRnd + 1) + minRnd
        );
        // console.log(rndNo);
        let rstatus = 'Failed after Install';
        if (rndNo !== 1) {
          rstatus = 'Damaged Upon Arrival';
        }
        const csItem = {
          claimNo: 'P220520' + i,
          claimType: rstatus,
          claimSubmitted: Date.now().toLocaleString('yyyy-MM-dd'),
          claimOriInvNo: 'OI220520' + i,
          claimSource: 'website',
          claimStatus: 'Approved',
          cRejectReason: 'Demo Reject'
        };
        rtnCSData.push(csItem);
      } while (i < 40);
      resolve({ data: rtnCSData });
    });

    /* return new Promise((resolve, reject) => {
      this.getOneByParams(`${this.baseURL}${this.endpoint}`, params)
        .then((response: any) => {
          const data = this.setLocalIndex(response.data);
          const result = { ...response, data };
          if (result.content) {
            resolve(result);
          } else {
            const newResponse = { ...result };
            newResponse.content = [];
            resolve(newResponse);
          }
        })
        .catch(error => {
          reject(error);
        });
    });*/
  }

  public sendInvoiceByEmail(addresses: string[], invoicesNumbers: any[]) {
    return new Promise((resolve, reject) => {
      const emailEndpoint = `${this.baseURL}warrantyapp/v1/part-claim/claim-pdf-files/email?claims=${invoicesNumbers}&email=${addresses}`;
      this.doRequest({
        method: 'get',
        url: emailEndpoint
      })
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  public sendClaimByEmail(addresses: string[], claimNumbers: any[]) {
    return new Promise((resolve, reject) => {
      const emailEndpoint = `${this.baseURL}accountapp/v1/invoice/send/email`;
      this.doRequest({
        method: 'post',
        url: emailEndpoint,
        data: {
          emailsToSend: addresses,
          invoicesNumber: claimNumbers
        }
      })
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public objToQueryString(obj: any) {
    // console.log(obj);
    const keyValuePairs = [];
    for (let i = 0; i < Object.keys(obj).length; i += 1) {
      keyValuePairs.push(
        `${encodeURIComponent(Object.keys(obj)[i])}=${encodeURIComponent(
          Object.values(obj)[i].toString()
        )}`
      );
    }
    return keyValuePairs.join('&');
  }
  public strParseDt(dtSubmit: string) {
    // let dt = dtSubmit.toString();
    try {
      // debugger;
      return (
        dtSubmit.toString().substr(0, 4) +
        '-' +
        dtSubmit.toString().substr(4, 2) +
        '-' +
        dtSubmit.toString().substr(6, 2)
      );
    } catch {
      // console.log('');
    }
    return dtSubmit;
  }

  public getCSPartDetails(accountId: any, cspDetails: any) {
    return new Promise((resolve, reject) => {
      // console.log(cspDetails);

      /* const iParams: ICSPartDetailsAPIParams = {
        claimType: '',
        prevClaimNumber: cspDetails.cspClaimNo,
        partNumber: cspDetails.csPartNo
      };*/
      const iParams: ICSPartDetailsAPIParams = {
        claimType: '',
        prevClaimNumber: '',
        partNumber: ''
      };

      if (cspDetails.claimType.substring(0, 5) === 'Damag') {
        iParams.claimType = 'damag';
      } else if (cspDetails.claimType.substring(0, 5) === 'Faile') {
        iParams.claimType = 'part';
      }
      iParams.prevClaimNumber = cspDetails.cspClaimNo;
      iParams.partNumber = cspDetails.csPartNo;

      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/getPartDetails?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then((response: any) => {
          // console.log('Response Data');
          resolve({ data: response.data });
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }
  
  public getCSPartDetailsProductWarranty(accountId: any, cspDetails: any) {
    return new Promise((resolve, reject) => {
      // console.log(cspDetails);

      /* const iParams: ICSPartDetailsAPIParams = {
        claimType: '',
        prevClaimNumber: cspDetails.cspClaimNo,
        partNumber: cspDetails.csPartNo
      };*/
      const iParams: ICSPartDetailsAPIParams = {
        claimType: '',
        prevClaimNumber: '',
        partNumber: ''
      };
      iParams.claimType = 'prod';
      iParams.prevClaimNumber = cspDetails.cspClaimNo;
      iParams.partNumber = cspDetails.csPartNo;

      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/getPartDetails?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then((response: any) => {
          // console.log('Response Data');
          resolve({ data: response.data });
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }
  public getClaimsOutStandingDetails(accountId: any) {
    return new Promise((resolve, reject) => {
      const csAPIUrl = `${this.baseURL}warrantyapp/v1/part-claim/refundApprovedDetails`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then((response: any) => {
          // console.log('Response Data');
          resolve({ data: response.data });
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }

  public getClaimInvoiceDateByInvNo(accountId: any, invoiceNo: string) {
    return new Promise((resolve, reject) => {
      const iParams: any = { invoiceNumber: invoiceNo };
      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/invoice-date?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then((response: any) => {
          // console.log('Response Data');
          resolve({ data: response });
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }

  public getClaimStatusHistory(accountId: any, filters: any, pagination?: any) {
    return new Promise((resolve, reject) => {
      // const params = this.buildClaimStatusHistoryParams(accountId, filters);
      const i: number = 0;
      const rtnCSData: ClaimStatusModel[] = [];
      // debugger;
      const iParams: IClaimStatusAPIParams = {
        claimsStatus: filters.status ? filters.status : 'All Status',
        claimsType: filters.orderStatus ? filters.orderStatus : 'All Claims',
        dateFilter: '',
        itemType: 'Claim Number',
        itemNumber: '',
        pageNumber: 0,
        pageSize: 20,
        sortField: '',
        sortDirection: ''
      };
      if (
        pagination &&
        pagination.pageSize !== undefined &&
        pagination.pageNumber !== undefined
      ) {
        iParams.pageSize = pagination.pageSize;
        iParams.pageNumber = pagination.pageNumber;
      }
      if (iParams.claimsType.substring(0, 5) === 'Damag') {
        iParams.claimsType = 'Damag';
      } else if (iParams.claimsType.substring(0, 5) === 'Produ') {
        iParams.claimsType = 'Prod';
      }else if (iParams.claimsType.substring(0, 5) === 'Faile') {
        iParams.claimsType = 'Part';
      }
      if (!(filters.dateRange === undefined || filters.dateRange === null)) {
        iParams.dateFilter =
          filters.dateRange.start.format('YYYY-MM-DD') +
          ' - ' +
          filters.dateRange.end.format('YYYY-MM-DD');
      }
      if (filters.csSearchVal != null && filters.csSearchKey.length > 2) {
        if (filters.csSearchVal === 'Claim Number') {
          iParams.itemType = filters.csSearchVal;
          iParams.itemNumber = filters.csSearchKey;
          iParams.dateFilter = '';
        } else {
          iParams.itemType = filters.csSearchVal;
          iParams.itemNumber = filters.csSearchKey;
        }
      }
      // console.log(filters.sort, 'Sorting');
      if (filters.sort && filters.sort.order !== undefined) {
        iParams.sortDirection = filters.sort.order;
      }
      if (filters.sort.type === 'claimNo') {
        iParams.sortField = 'claim_number';
      } else if (filters.sort.type === 'claimType') {
        iParams.sortField = 'claim_type';
      } else if (filters.sort.type === 'claimSubmitted') {
        iParams.sortField = 'claim_submitted_date';
      } else if (filters.sort.type === 'claimSource') {
        iParams.sortField = 'claim_source';
      } else if (filters.sort.type === 'claimStatus') {
        iParams.sortField = 'claim_status';
      }

      // return new Promise((resolve, reject) => {
      // console.log('Response Data Log -1');
      const cPartInfo: any[] = [];
      const csAPIUrl = `${
        this.baseURL
      }warrantyapp/v1/part-claim/searchClaims?${this.objToQueryString(
        iParams
      )}`;
      this.doRequest({
        method: 'get',
        url: csAPIUrl
      })
        .then((response: any) => {
          // console.log('Response Data');

          if (
            response.data &&
            response.data.claimsList &&
            response.data.claimsList.length &&
            response.data.claimsList.length > 0
          ) {
            for (const csItem of response.data.claimsList) {
              if (csItem) {
                const cDetails = {
                  claimNo: csItem.claimNumber,
                  claimType: this.gDClaimType(csItem.claimType, ''),
                  claimSubmitted: csItem.claimSubmittedDate,
                  claimOriInvNo: csItem.originalInvoiceNumber,
                  claimSource:
                    csItem.claimSource === 'NS3'
                      ? 'Website'
                      : csItem.claimSource,
                  claimStatus: csItem.claimStatus,
                  cRejectReason: csItem.claimRejectionReason,
                  poNumber: csItem.poNumber,
                  refNumber: csItem.refNumber,
                  csPartDetails:
                    csItem.lineItems !== undefined &&
                    csItem.lineItems.length !== undefined &&
                    csItem.lineItems.length > 0
                      ? csItem.lineItems.map((cspItem: any) => {
                          return {
                            cspClaimNo: csItem.claimNumber,
                            csPartNo: cspItem.partNumber,
                            csId: cspItem.id,
                            cspQtyOnOriInv: cspItem.quantityOnOriginalInvoice,
                            cspOriInvNo: cspItem.originalInvoiceNumber,
                            cspInvoiceNo: cspItem.invoiceNumber,

                            cspUnitPrice: cspItem.unitPrice,
                            cspTotalPrice: cspItem.totalPrice,
                            cspQtyPartsOnClaim: cspItem.quantityPartsOnClaim,
                            cspQtyCredited: cspItem.quantityCredited,
                            cspAStatus: cspItem.creditStatus,
                            cspErrInfo:
                              cspItem.errors == null ? 'NA' : cspItem.errors,
                            cspRClaimRefNo:
                              cspItem.newClaimNumber == null
                                ? ''
                                : cspItem.newClaimNumber,
                            creditDate: cspItem.creditDate,
                            invoiceNumber: cspItem.invoiceNumber,
                            claimType: this.gDClaimType(csItem.claimType, ''),
                            claimSource: csItem.claimSource
                          };
                        })
                      : []
                };

                rtnCSData.push(cDetails);
              }
            }
          }

          resolve({
            data: rtnCSData,
            totalPages: response.data.totalPages,
            totalClaims: response.data.totalClaims
          });
        })
        .catch((error: any) => {
          // console.log(error);
          reject(error);
        });
    });
  }

  private gDClaimType = (cType: string, dVal?: string) => {
    /* 
    if (cType === null || cType === undefined) {
      return dVal ? dVal : 'All Claims';
    }
    cType =
      cType === 'Damag'
        ? i18n.t('claimStatus.pDamagedUponArrival')
        : i18n.t('claimStatus.pFailedAfterInstall');
    return cType;
    */

    switch (cType) {
      case null:
        return  `${i18n.t('claimStatus.allClaims')}`
      case undefined:
        return `${i18n.t('claimStatus.allClaims')}`
      case 'Damag':
        return `${i18n.t('claimStatus.pDamagedUponArrival')}`
        break;
      case 'Part':
        return `${i18n.t('claimStatus.pFailedAfterInstall')}`
        break;
      case 'Prod':
        return `${i18n.t('claimStatus.productWarranty')}`
        break;
      case 'PROD':
          return `${i18n.t('claimStatus.productWarranty')}`
          break;  
      default:
        return `${i18n.t('claimStatus.allClaims')}`
    }
  };

  private buildClaimStatusHistoryParams = (accountId: any, filters: any) => {
    const start = moment(
      new Date(new Date().setFullYear(new Date().getFullYear() - 5))
    );
    const end = moment(new Date());
    if (filters) {
      const parameters: any = {
        accountId,
        fromDate:
          filters.dateRange && filters.dateRange.start
            ? filters.dateRange.start.format('MMDDYYYY')
            : start.format('MMDDYYYY'),
        toDate:
          filters.dateRange && filters.dateRange.end
            ? filters.dateRange.end.format('MMDDYYYY')
            : end.format('MMDDYYYY'),
        status: '',
        // orderStatus: filters.orderStatus,
        invoiceNo: filters.invoiceNumber ? filters.invoiceNumber : '',
        orderNo: filters.orderNumber ? filters.orderNumber : '',
        purchaseOrderdNo: filters.orderReference ? filters.orderReference : ''
      };
      return parameters;
    } else {
      const parameters: any = {
        accountId,
        fromDate: start.format('MMDDYYYY'),
        invoiceNo: '',
        orderNo: '',
        purchaseOrderdNo: '',
        status: '',
        toDate: end.format('MMDDYYYY')
      };
      return parameters;
    }
  };
  public originalInvoice() {
    return new Promise((resolve, reject) => {
      const originalInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/original/invoice`;
      this.doRequest({
        method: 'get',
        url: originalInvoiceEndpoint
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          if (response.status === 200) {
            resolve(result);
          } else if (response.status === 204) {
            reject('No original invoices');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  public oldestInvoice(pagination: ICSSvcPagination) {
    const params = this.buildOldestInvoicesParams(pagination);
    return new Promise((resolve, reject) => {
      const oldestInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/oldest/invoice`;
      this.doRequest({
        method: 'get',
        url: oldestInvoiceEndpoint,
        params
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          // console.log(
          //   'olderst invoice:' + JSON.stringify(response.totalCredit)
          // );
          if (response.status === 200) {
            resolve(result);
          } else if (response.status === 204) {
            reject('No oldest invoices');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public creditDebitSummary(type: any) {
    return new Promise((resolve, reject) => {
      const summaryEndpoint = `${this.baseURL}accountapp/v1/invoice/credit/debit/summary?type=${type}`;
      this.doRequest({
        method: 'get',
        url: summaryEndpoint
      })
        .then((response: any) => {
          // const data = this.setLocalIndex(response.data);
          const result = response.data;
          if (response.status === 200) {
            resolve(result);
          } else if (response.status === 204) {
            reject('No Summary');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  public selectCreditOriginal(filters: any, pagination: any) {
    const params = this.buildOriginalCreditParams(filters, pagination);
    // console.log(params);
    const manualcreditInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/select/credit`;
    return new Promise((resolve, reject) => {
      this.getOneByParams(`${manualcreditInvoiceEndpoint}`, params)
        .then((response: any) => {
          const data = this.setLocalIndex(response.data);
          const result = { ...response, data };
          if (result.content) {
            resolve(result);
          } else {
            const newResponse = { ...result };
            newResponse.content = [];
            resolve(newResponse);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  private buildOriginalCreditParams = (
    filters: any,
    pagination: ICSSvcPagination
  ) => {
    // console.log(pagination);
    const parameters: any = {
      page: pagination.page,
      size: pagination.size,
      listOfOriginalInvoices: filters.listOfOriginalInvoices,
      type: 'original'
    };
    Object.keys(parameters).forEach(key =>
      !parameters[key] ? delete parameters[key] : ''
    );
    return parameters;
  };
  public selectCredit(filters: any, pagination: any) {
    const params = this.buildCreditParams(filters, pagination);
    // console.log(params);
    const manualcreditInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/select/credit`;
    return new Promise((resolve, reject) => {
      this.getOneByParams(`${manualcreditInvoiceEndpoint}`, params)
        .then((response: any) => {
          const data = this.setLocalIndex(response.data);
          const result = { ...response, data };
          if (result.content) {
            resolve(result);
          } else {
            const newResponse = { ...result };
            newResponse.content = [];
            resolve(newResponse);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public exportSelectedInvoicesSummary(
    type: string,
    paymentId: string,
    debitDataList: any,
    creditDataList: any,
    page: string
  ) {
    return new Promise((resolve, reject) => {
      let exportInvoicesEndpoint = '';
      if (page === 'admin') {
        exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}&summary=admin`;
      } else if (page === 'original') {
        exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}&summary=original`;
      } else {
        exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}`;
      }
      // page === 'manual'
      //   ? `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}`
      //   :
      // page === 'admin'?
      // `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}&summary=admin`
      // : page === 'original'
      //   ? `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}&summary=original`
      //   : `${this.baseURL}accountapp/v1/invoice/selected/cranddr/export?type=${type}&payment_id=${paymentId}`;
      this.doRequest({
        method: 'post',
        url: exportInvoicesEndpoint,
        data: {
          creditInvoice: [],
          debitInvoice: []
        },
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public exportSelectedInvoices(type: string, selectedInvoice: any) {
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/selected/export?type=${type}`;
      this.doRequest({
        method: 'post',
        url: exportInvoicesEndpoint,
        data: selectedInvoice,
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public exportSelectedPaidInvoices(type: string, selectedInvoice: any) {
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/payments/history/selected/export?type=${type}`;
      this.doRequest({
        method: 'post',
        url: exportInvoicesEndpoint,
        data: selectedInvoice,
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public downloadAll(
    filename: string,
    type: string,
    filtervalues: ICSSvcFilters,
    pagination: ICSSvcPagination
  ) {
    // const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/export?type=${type}`;
    let exportParams: any;
    if (filtervalues !== undefined) {
      exportParams = this.buildClaimStatusParams(filtervalues, pagination);
    }
    if (filtervalues === undefined && pagination) {
      exportParams = {
        page: pagination.page,
        size: pagination.size,
        sort: 'invoiceNumber,asc'
      };
    }

    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/export?type=${type}`;
      this.doRequest({
        method: 'get',
        url: exportInvoicesEndpoint,
        responseType: 'blob',
        params: exportParams
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public exportInvoices(
    type: string,
    filtervalues: ICSSvcFilters,
    pagination: ICSSvcPagination
  ) {
    let exportParams: any;
    if (filtervalues !== undefined) {
      exportParams = this.buildClaimStatusParams(filtervalues, pagination);
    }
    if (filtervalues === undefined && pagination) {
      exportParams = {
        page: pagination.page,
        size: pagination.size,
        sort: 'invoiceNumber,asc'
      };
    }
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/export?type=${type}`;
      this.doRequest({
        method: 'get',
        url: exportInvoicesEndpoint,
        responseType: 'blob',
        params: exportParams
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public exportPaymentHistoryInvoices(
    type: string,
    filtervalues: ICSSvcFilters,
    pagination: ICSSvcPagination
  ) {
    // let exportParams: any;
    // if (filtervalues !== undefined) {
    //   exportParams = this.buildInvoicesParams(filtervalues, pagination);
    // }
    const activeAccount = localStorage.getItem('activeAccount');
    const params = this.buildClaimStatusHistoryParams(
      activeAccount,
      filtervalues
    );
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/payments/history/export?type=${type}`;
      this.doRequest({
        method: 'post',
        url: exportInvoicesEndpoint,
        responseType: 'blob',
        data: params
        // params: exportParams,
        // data: {
        //   accountId: '608209',
        //   fromDate: '',
        //   invoiceNo: '',
        //   orderNo: '',
        //   purchaseOrderdNo: '',
        //   status: '',
        //   toDate: ''
        // }
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public exportOriginalInvoices(
    type: string,
    filtervalues: ICSSvcFilters,
    pagination: ICSSvcPagination
  ) {
    let exportParams: any;
    if (filtervalues !== undefined) {
      exportParams = this.buildClaimStatusParams(filtervalues, pagination);
    }
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/original/export?type=${type}`;
      this.doRequest({
        method: 'get',
        url: exportInvoicesEndpoint,
        responseType: 'blob',
        params: exportParams
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  public exportOldestInvoices(
    type: string,
    filtervalues: ICSSvcFilters,
    pagination: ICSSvcPagination
  ) {
    let exportParams: any;
    if (filtervalues !== undefined) {
      exportParams = this.buildClaimStatusParams(filtervalues, pagination);
    }
    return new Promise((resolve, reject) => {
      const exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/oldest/export?type=${type}`;
      this.doRequest({
        method: 'get',
        url: exportInvoicesEndpoint,
        responseType: 'blob',
        params: exportParams
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public gClaimConfirmation(claims: any[]) {
    return new Promise((resolve, reject) => {
      // debugger;
      // part-cliam/claim-files-availability?claims
      const downloadClaimConfirmationEndpoint = `${
        this.baseURL
      }warrantyapp/v1/part-claim/claim-files-availability?claims=${claims.join(
        ','
      )}`;
      this.doRequest({
        method: 'get',
        url: downloadClaimConfirmationEndpoint
        // responseType: 'blob' as 'json'
      })
        .then((response: any) => {
          // console.log(response);
          // debugger;
          const result = response.data;
          // console.log(result);
          if (response.status === 200) {
            resolve(result);
          } else if (response.status === 204) {
            reject('No Summary');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  public downloadClaimConfirmation(claims: any[]) {
    return new Promise((resolve, reject) => {
      const downloadClaimConfirmationEndpoint = `${this.baseURL}warrantyapp/v1/part-claim/download-pdf-files`;
      this.doRequest({
        method: 'get',

        url: this.buildDownloadClaimReferenceUrl(
          claims,
          downloadClaimConfirmationEndpoint
        ),

        responseType: 'blob' as 'json'
      })
        .then((response: any) => {
          // console.log(response);
          // debugger;
          if (response.status === 200 || response.status === 206) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No claims');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
  private buildDownloadClaimReferenceUrl(claimReferences: any[], url: string) {
    let newUrl = url;
    if (claimReferences.length > 1) {
      claimReferences.map((claim, index) => {
        newUrl +=
          index === 0
            ? `?claims=${claim.claimNumber}`
            : `,${claim.claimNumber}`;
      });
    } else {
      claimReferences.map((claim, index) => {
        newUrl +=
          index === 0 ? `/${claim.claimNumber}` : `,${claim.claimNumber}`;
      });
    }

    return newUrl;
  }

  public downloadInvoices(invoicesNumbers: any[]) {
    return new Promise((resolve, reject) => {
      const downloadInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/download?`;
      this.doRequest({
        method: 'get',
        url: this.buildDownloadInvoicesUrl(
          invoicesNumbers,

          downloadInvoicesEndpoint
        ),

        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200 || response.status === 206) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  private buildDownloadInvoicesUrl(invoicesNumbers: any[], url: string) {
    // console.log('buildDownloadInvoicesUrl', invoicesNumbers);
    let newUrl = url;
    invoicesNumbers.map((invoice, index) => {
      // console.log('invoiceNo', invoice.invoiceNo);
      newUrl +=
        index === 0
          ? `number=${invoice.invoiceNo}:${invoice.invoiceDate}`
          : `&number=${invoice.invoiceNo}:${invoice.invoiceDate}`;
    });

    return newUrl;
  }

  public downloadInvoice(invoice: string, date: string) {
    return new Promise((resolve, reject) => {
      const downloadInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/preview?number=${invoice}:${date}`;
      this.doRequest({
        method: 'get',
        url: downloadInvoiceEndpoint,
        responseType: 'blob'
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoice');
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  public payInvoicesByCreditsOriginal(
    invoicePayments: IInvoiceCreditPayment[],
    amountDetails: any
  ) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/pay/credits?type=original`,
        data: {
          invoicePayments,
          ...amountDetails
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public payInvoicesByCredits(
    invoicePayments: IInvoiceCreditPayment[],
    amountDetails: any
  ) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/pay/credits`,
        data: {
          invoicePayments,
          ...amountDetails
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  public manualApplyCredits(
    invoicePayments: IInvoiceCreditPayment[],
    amountDetails: any
  ) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/pay/manual/credits`,
        data: {
          invoicePayments,
          ...amountDetails
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public manualyAutoApplyCredits(invoiceDatas: any) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/pay/auto/credits`,
        data: invoiceDatas
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public allowUserModifyInvoices(accountId: string, clientIdentity: string) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/permission/enable`,
        data: {
          accountId,
          clientIdentity
        }
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public disableUserModifyInvoices(accountId: string, clientIdentity: string) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        method: 'POST',
        url: `${this.baseURL}accountapp/v1/invoice/permission/disable`,
        data: {
          accountId,
          clientIdentity
        }
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public downloadInvoiceByOrderno(invoice: string, orderno: string) {
    return new Promise((resolve, reject) => {
      const downloadInvoiceEndpoint = `${this.baseURL}accountapp/v1/invoice/previewByOrderNumber?number=${invoice}&orderNumber=${orderno}`;
      this.doRequest({
        method: 'get',
        url: downloadInvoiceEndpoint,
        responseType: 'blob'
      })
        .then(response => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoice');
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const cObjCSService = new ClaimStatusService();
Object.freeze(cObjCSService);

export default cObjCSService;
